/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { ContentCopy, ReplayCircleFilledOutlined, Cancel } from "@mui/icons-material";
import Context from "../context/context";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { XIcon } from "@heroicons/react/solid";
import axios from "axios";
import { openDB } from "idb";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const TableRowCollapse = ({ visible, setIsOrdersTablePopUpOpen, searchHandler, paymentProps, setPaymentOptionOpen, runningOrder, setRunningOrder, setOrderProps }) => {

  const page = window.location.pathname;
  const context = useContext(Context);
  const location = useLocation()

  const {
    setUnAuthPopup,
    setForceRenderPage1,
    setForceRenderOrdersPage,
    calculateOrderValues,
    setEditedOrderData,
    putOrdersTimeout,
    deleteOrder,
    PrintKotInvoice,
    PrintInvoice,
    selectMenu,
    showWarning
  } = context;

  let restrictions = JSON.parse(sessionStorage.getItem("restrictions")) || []
  const [itemsList, setItemsList] = useState(null);
  const [kotItemDetails, setKotItemDetails] = useState([]);
  const Navigate = useNavigate();
  const [uuid, setUuid] = useState(false);
  const [chargesPopVisible, setIsChargesPopVisible] = useState(false);
  const [discountPopVisible, setDiscountPopVisible] = useState(false);
  const [copymsg, setCopymsg] = useState(false);
  const [activeNave, setActiveNav] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [cancelledItems, setCancelledItems] = useState({});
  const [removedItemExtras, setRemovedItemExtras] = useState({})

  const [printDependencies, setPrintDependencies] = useState({})
  // load itemsList & printDependencies
  useEffect(() => {
    if (!runningOrder?.order_uuid) return;
    setKotItemDetails([].concat.apply([],
      [].concat.apply([], runningOrder?.order_kot_details)
        ?.map(kot => kot?.kot_items_details?.map(item => ({ ...item, kot: kot.kot })))
    ))
    const loadData = async () => {
      let indexedDB = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = indexedDB.transaction("outlet", "readonly").objectStore("outlet");

      const outlet = await tx.get(localStorage.getItem('outlet_uuid'))
      const invoice_setup = await outlet?.invoice_setup?.find(i => i.brand_uuid === runningOrder?.brand_uuid)
      const kot_setup = await outlet?.kot_setup

      tx = indexedDB.transaction("item_grouping", "readonly").objectStore("item_grouping");
      const item_groups = await tx.getAll();

      tx = indexedDB.transaction("item", "readonly").objectStore("item");
      const items = await tx.getAll();

      tx = indexedDB.transaction("category", "readonly").objectStore("category");
      const categoryDetails = await tx.getAll();

      tx = indexedDB.transaction("payment_modes", "readonly").objectStore("payment_modes");
      const paymentMode = await tx.getAll();

      tx = runningOrder?.seat_uuid && indexedDB.transaction("seats", "readonly").objectStore("seats");
      const seat = runningOrder?.seat_uuid ? await tx.get(runningOrder?.seat_uuid) : '';

      tx = indexedDB.transaction("user", "readonly").objectStore("user");
      const users = await tx.getAll();

      setItemsList(items)
      setPrintDependencies({
        invoice_setup,
        kot_setup,
        item_groups,
        items,
        categoryDetails,
        paymentMode,
        section_name: seat ? outlet?.section_details?.find(i => i.section_uuid === seat?.section_uuid)?.section_name : '',
        seat_name: seat?.seat_name || '',
        users,
        dateFormat: outlet?.setup?.date_format
      })
    }
    loadData()
  }, [runningOrder])

  // Print Functions
  const printKotInvoice = async (kotNumber, order_json = runningOrder) => {

    if (!order_json) return console.log('No order found to print');
    PrintKotInvoice({
      dependencies: {
        user_title: printDependencies?.users?.find(i => i.user_uuid === order_json?.payment_by_user_uuid)?.user_title,
        order_json,
        paymentMode: printDependencies?.paymentMode,
        categoryDetails: printDependencies?.categoryDetails,
        kot_setup: printDependencies?.kot_setup,
        kotNumber,
        section_name: printDependencies?.section_name,
        seat_name: printDependencies?.seat_name,
        itemsDetails: printDependencies?.items,
        dateFormat: printDependencies?.dateFormat,
      },
      item_groups: printDependencies?.item_groups,
      callback: () => setShowKots(false)
    })
  };

  const handleInvoicePrint = async params => {

    const { num, ebill, debug_print, order_json = runningOrder, coupons_messages = [] } = params;

    if (!order_json) return console.log('No order found to print')
    const browser_print = !ebill && +printDependencies?.invoice_setup?.printer_name === 0 ? true : false;

    await PrintInvoice({
      dependencies: {
        invoice_setup: printDependencies?.invoice_setup,
        order_json,
        seat_name: printDependencies?.seat_name,
        section_name: printDependencies?.section_name,
        user_title: printDependencies?.users?.find(i => i.user_uuid === order_json?.payment_by_user_uuid)?.user_title,
        paymentMode: printDependencies?.paymentMode,
        itemsDetails: printDependencies?.items,
        kotItemDetails: kotItemDetails?.filter(item => +item?.order_item_status !== 2),
        couponsMessages: coupons_messages
      },
      invoice_details: {
        num: browser_print ? 1 : num,
        ebill,
        debug_print: browser_print ? 'true' : debug_print,
        browser_print,
        customer_mobile: order_json?.customer_mobile,
        bill_total: order_json?.order_total
      },
      // callback: () => setShowKots(false)
    })
    invoice(browser_print ? 1 : num)
  }

  const onOrderDelete = async () => {
    let order_uuid = runningOrder.order_uuid
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("Orders", "readwrite").objectStore("Orders");
    const order = await tx.get(order_uuid)
    console.log("order-----------", order)
    const response = await axios({
      url: "https://api.myfooddo.com/order/deleteOrder",
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: [{ order_uuid }]
    })
    console.log(response)
    if (response.status === 200 && order) {
      const db2 = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const tx2 = await db2.transaction("Orders", "readwrite").objectStore("Orders");
      await tx2.delete(order_uuid);
    }
    if (response.status === 200) {

      searchHandler();
      setIsOrdersTablePopUpOpen(false);
      setRunningOrder(null)

    }
    console.log(response)
  }

  useEffect(() => setActiveNav("general"), []);

  const [editValue, setEditValue] = useState(null);

  function isOrderAvailableLocally(time) {
    const dates = JSON.parse(localStorage.getItem('dates_json'));

    console.log("is available offline ? ", dates.find(i => +i.date === +time))

    if (dates.find(i => +i.date === +time)) {
      console.log("order is available offline", dates.find(i => +i.date === +time))
      return true
    }
    else return false;
  }

  function handleUnpostedUUIDs(orderId, UPDATED_AT, path) {

    let unposted_orders_ids = JSON.parse(localStorage.getItem('unposted_orders_ids')) || [];
    unposted_orders_ids = unposted_orders_ids.filter(i => i.order_uuid !== orderId)

    unposted_orders_ids.push({
      order_uuid: orderId,
      UPDATED_AT: UPDATED_AT,
      path
    })

    localStorage.setItem('unposted_orders_ids', JSON.stringify(unposted_orders_ids));
  }

  function performCalculation(order) {

    order.order_kot_details.forEach(kot => {

      kot.kot_items_details.forEach((kot_item, index) => {

        let qty = document.querySelector(`[kot="${+kot.kot}"][item-index="${+index}"].qty`);
        let unit_price = document.querySelector(`[kot="${+kot.kot}"][item-index="${+index}"].unit-price`);

        if (!qty || !unit_price) return;

        const itemDetail = itemsList.find(i => i.item_uuid === kot_item.item_uuid).outlet_wise_item_details
          .find(i => i.outlet_uuid === runningOrder.outlet_uuid).other_details;

        const gst_prst = +itemDetail.item_gst;
        const vat_prst = +itemDetail.item_vat;

        console.log("gst_prst, vat_prst", gst_prst, vat_prst);

        qty = +qty.value;
        unit_price = +unit_price.value;
        console.log("qty, unit_price", qty, unit_price)

        if (
          +kot_item.order_item_qty === +qty
          && kot_item.order_item_unit_price === +unit_price
          && !removedItemExtras?.[+kot.kot]?.[index]
        ) return console.log('all values are same.')

        kot_item.order_item_qty = +qty;
        kot_item.order_item_unit_price = +unit_price;

        kot_item.addon_details = kot_item.addon_details?.filter((x, ai) =>
          !removedItemExtras?.[+kot.kot]?.[index]?.addons?.includes(ai)
        ) || []

        kot_item.multi_details = kot_item.multi_details?.filter((x, mi) =>
          !removedItemExtras?.[+kot.kot]?.[index]?.multi?.includes(mi)
        ) || []

        let addons_amt = 0;
        if (kot_item.addon_details && kot_item.addon_details.length > 0)
          kot_item.addon_details.forEach((addon) => (addons_amt += +addon.price));

        let multi_amt = 0;
        if (kot_item.multi_details && kot_item.multi_details.length > 0)
          kot_item.multi_details.forEach((multi) => (multi_amt += +multi.price));

        let discount = +kot_item.order_item_unit_discount || 0;
        let price = +kot_item.order_item_unit_price + +addons_amt + +multi_amt - (+discount);
        console.log(kot_item.order_item_unit_price, addons_amt, multi_amt, discount)

        let gst = (+price * (+gst_prst)) / 100;
        let vat = (+price * (+vat_prst)) / 100;
        let total = (+price + gst + vat) * +kot_item.order_item_qty;

        console.log(gst, vat, total);

        kot_item.order_item_taxable_value = +((price * +kot_item.order_item_qty).toFixed(2));
        kot_item.order_item_amount_inclusive_taxes = +(total.toFixed(2));

        console.log('updated item prizes : ', kot_item);
      })

      kot.kot_items_details.forEach((item, i) => {
        if (!item) return;
        if (cancelledItems[kot.kot]?.includes(i)) {
          item.order_item_status = "2";
          item.updated_at = Date.now()
        } else if (+item.order_item_status === 2) {
          item.order_item_status = sessionStorage.getItem('kot_type');
          item.updated_at = Date.now()
        }
      });
    })

    const chargesAndDiscounts = (chargesInputValues || []).concat(discountsInputValues || []);
    chargesAndDiscounts.sort((a, b) => (+a.id) - (+b.id));

    if (chargesAndDiscounts.length > 0) order.charges_and_discounts = chargesAndDiscounts;
    order = calculateOrderValues(order, true)
    order.working_day = new Date(`${workingDay}`).setUTCHours(0, 0, 0, 0) || order.working_day;
    order.IsSynched = 0;

    console.log('updated order', order);
    if (page.includes('report-orders')) {
      const isoffline = isOrderAvailableLocally(order.working_day);
      delete order.IsSynched
      order.IDENTIFIER = order.order_uuid;
      order.BACKUP = 1;
      order.IndexDbSts = 1;

      if (isoffline) {
        console.log("order is available offline, thus not allowed to put on database through this method.");
        order.SRC = "IDB";
        order.UPDATED_AT = Date.now();
        handleUnpostedUUIDs(order.order_uuid, order.UPDATED_AT, order.SRC);
        putOrdersTimeout();
      }
      else {
        order.SRC = "API";
        order.UPDATED_AT = Date.now();
        handleUnpostedUUIDs(order.order_uuid, order.UPDATED_AT, order.SRC);
        putOrdersTimeout();
      }
    }

    setRemovedItemExtras({})
    return order;
  }

  function updateOrder() {

    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.onerror = err => console.warn(err);
    DBOpenReq.onsuccess = ev => {

      let collection;
      if (+runningOrder.order_status === 4) collection = "Orders";
      else if (+runningOrder.order_status < 4) collection = "running_orders";
      else return;

      let tx = ev.target.result.transaction(collection, "readwrite");
      let store = tx.objectStore(collection);

      let order = runningOrder;
      console.log(order);

      order = performCalculation(order);
      store.put(order);

      if (order.seat_uuid && runningOrder.order_status < 4) {

        let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats")) || [];
        let object = onorder_seats.filter((obj) => obj.seat_uuid === order.seat_uuid)[0];
        object.price = +order.order_total;

        if (onorder_seats.length > 0)
          onorder_seats = onorder_seats.filter(
            (obj) => obj.seat_uuid !== order.seat_uuid
          );

        onorder_seats.push(object);
        localStorage.setItem("onorder_seats", JSON.stringify(onorder_seats));

        if (page.includes("/page1"))
          setForceRenderPage1(uuidv4() + uuidv4());
      }
      setRunningOrder({ data: order });
    }
  }

  useEffect(() => {
    if (runningOrder && runningOrder.data) {
      setEditedOrderData(runningOrder.data);
      setRunningOrder(runningOrder.data);
      setEditValue(false);
    }
  }, [runningOrder])

  const [showInvoiceMenu, setShowInvoiceMenu] = useState(null);
  const [showKots, setShowKots] = useState(null);

  const invoice = type => {

    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", (err) => console.warn(err));
    DBOpenReq.addEventListener("success", (ev) => {

      let collection;
      if (+runningOrder.order_status === 4) collection = "Orders";
      else if (+runningOrder.order_status < 4) collection = "running_orders";
      else return;

      let tx = ev.target.result.transaction(collection, "readwrite");
      let store = tx.objectStore(collection);

      let order = runningOrder;
      let object = {
        at: Date.now(),
        copies: type,
        user_uuid: localStorage.getItem("user_uuid"),
      };
      order.invoice_prints = order.invoice_prints || [];
      order.invoice_prints.push(object);
      order.IsSynched = 0;

      if (page.includes('report-orders')) {

        const isoffline = isOrderAvailableLocally(order.working_day);
        delete order.IsSynched
        order.IDENTIFIER = order.order_uuid;
        order.BACKUP = 1;
        order.IndexDbSts = 1;

        if (isoffline) {
          console.log("order is available offline, thus not allowed to put on database through this method.");
          order.SRC = "IDB";
          order.UPDATED_AT = Date.now();
          handleUnpostedUUIDs(order.order_uuid, order.UPDATED_AT, order.SRC);
          putOrdersTimeout();
        }
        else {
          order.SRC = "API";
          order.UPDATED_AT = Date.now();
          handleUnpostedUUIDs(order.order_uuid, order.UPDATED_AT, order.SRC);
          putOrdersTimeout();
        }
      }

      store.put(order);

      if (order.seat_uuid && runningOrder.order_status < 4) {
        let onseat_orders = JSON.parse(localStorage.getItem("onorder_seats"));
        onseat_orders = onseat_orders.filter(i => i.seat_uuid !== order.seat_uuid)
        let object = {
          seat_uuid: order.seat_uuid,
          created_at: order.created_at,
          price: order.order_total,
          title: order.local_order_id,
          uuid: order.order_uuid,
          invoiced: 1
        };

        onseat_orders.push(object);
        localStorage.setItem("onorder_seats", JSON.stringify(onseat_orders));
      }

      if (page.includes('/page1'))
        setForceRenderPage1(uuidv4() + uuidv4());
      else if (page.includes('/orders'))
        setForceRenderOrdersPage(uuidv4() + uuidv4());

      setShowInvoiceMenu("close");
      setRunningOrder(order);
      setEditedOrderData(order);
    });
  }

  const [kot_list, setKot_list] = useState(null);
  const [chargesInputValues, setChargesInputValues] = useState(null);
  const [discountsInputValues, setDiscountsInputValues] = useState(null);
  const [editedData, setEditedData] = useState(null);
  const [workingDay, setWorkingDay] = useState(null);

  useEffect(() => {
    if (!runningOrder) return

    if (runningOrder && runningOrder.order_kot_details) {
      const list = [];
      const kot_items_details = {};
      const cancelledItemsList = {};

      runningOrder.order_kot_details?.forEach((detail, i) => {

        kot_items_details[detail?.kot] = {};
        list.push(detail?.kot)

        detail?.kot_items_details?.forEach((item, i) => {

          const obj = {
            price: +item.order_item_unit_price,
            qty: +item.order_item_qty
          }

          if (+item?.order_item_status === 2) {
            cancelledItemsList[detail.kot] = cancelledItemsList[detail.kot] ? [...cancelledItemsList[detail.kot], i] : [i];
          }
          kot_items_details[detail?.kot][i] = obj;
        });
      })

      console.log("kot_items_details", kot_items_details);
      console.log("cancelled Items List", cancelledItemsList);

      setCancelledItems(cancelledItemsList);
      setEditedData({ data: kot_items_details });
      setKot_list(list);
    }
    if (runningOrder && runningOrder.charges_and_discounts) {
      const charges = [];
      const discounts = [];
      const data = runningOrder.charges_and_discounts;

      if (Array.isArray(data) && data.length > 0)
        data.forEach((data, i) => { if (data.type === "C") charges.push({ ...data, id: i }); else if (data.type === "D") discounts.push({ ...data, id: i }); });

      setChargesInputValues(charges);
      setDiscountsInputValues(discounts);
    }

    if (runningOrder)
      setWorkingDay(new Date(+runningOrder.working_day || runningOrder.working_day).getTime())
  }, [runningOrder])

  function onInputValChange(e, field, data) {
    console.log(e.currentTarget.value, field, data)
    let values = data.type === "C" ? chargesInputValues : data.type === "D" ? discountsInputValues : null;

    if (!values) return;

    values.forEach(value => {
      if (value.id === data.id) {

        if (field === 'title')
          value.title = e.currentTarget.value;

        else if (field === 'amount')
          if (data.amt)
            value.amt = +e.currentTarget.value;
          else if (data.percent >= 0)
            value.percent = +e.currentTarget.value;

        console.log(value)
        if (data.type === "C") setChargesInputValues(values);
        else if (data.type === "D") setDiscountsInputValues(values);
      }
    })
  }

  const openMenuToAddMoreItems = async () => {

    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const redirect = () => {
      if (page.includes('report-orders') && +runningOrder?.order_status === 4) {
        const order = { ...runningOrder }
        const isoffline = isOrderAvailableLocally(order.working_day);
        if (isoffline) {
          console.log("order is available offline, thus not allowed to put on database through this method.");
          order.SRC = "IDB";
          order.UPDATED_AT = Date.now();
          handleUnpostedUUIDs(order.order_uuid, order.UPDATED_AT, order.SRC);
          putOrdersTimeout();
        } else {
          delete order.IsSynched;
          order.IDENTIFIER = order.order_uuid;
          order.BACKUP = 1;
          order.IndexDbSts = 1;
          order.SRC = "API";
          order.UPDATED_AT = Date.now();
          handleUnpostedUUIDs(order.order_uuid, order.UPDATED_AT, order.SRC);
          (db.transaction("Orders", "readwrite").objectStore("Orders")).put(order);
        }
      } else setOrderProps({
        order_uuids: [runningOrder?.order_uuid],
        order_uuid: runningOrder?.order_uuid,
        seat_uuid: runningOrder?.seat_uuid,
        order_type: runningOrder?.order_type || '0'
      });

      const edit = +runningOrder?.order_status === 4 ? '?edit' : ''
      const path = `/page2/${runningOrder?.order_type || "0"}/${runningOrder?.order_uuid}${edit}`
      Navigate(path);
    }

    if (runningOrder?.seat_uuid) {
      // For seat orders
      const seat = await (db.transaction("seats", "readonly").objectStore("seats")).get(runningOrder?.seat_uuid)
      if (!seat?.menu_details?.[0]) return showWarning({
        message: 'Please Apply Menu to the Seat',
        classname: 'active-red'
      });
      sessionStorage.setItem('seat-menu-details', JSON.stringify(seat?.menu_details))
      selectMenu(seat?.menu_details?.[0], '0', redirect);
    }
    else {
      // For Nonseat orders
      selectMenu({ brand_uuid: runningOrder?.brand_uuid || null }, `${runningOrder?.order_type}`, () => {
        if (runningOrder?.order_uuid) sessionStorage.setItem("current-nonseat-order", runningOrder?.order_uuid);
        else sessionStorage.removeItem("current-nonseat-order");
        sessionStorage.setItem("current-nonseat-type", runningOrder?.order_type);
        redirect()
      })
    }
  }

  useEffect(() => console.log({ cancelledItems }), [cancelledItems])
  const [showDeliveryBox, toggleDeliveryBox] = useState(false);

  return (
    <>
      {runningOrder && <tr className="collapse" style={{ width: "60vw", zIndex: "1000" }}>
        <td
          colSpan={4}
          className={visible ? "active" : ""}
          style={{ padding: 0, overflowX: "hidden" }}
          onClick={e => {
            showKots !== "inside" && setShowKots(false);
            showInvoiceMenu !== "inside" && setShowInvoiceMenu(false);
          }}
        >
          <table>
            <thead
              className="bb b--green"
              style={{ position: "sticky", top: 0, zIndex: "100" }}
            >
              <tr>
                <td colSpan={24}>
                  <div className="collapse-nav" style={{ width: "100%" }}>
                    <div
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                      className={`collapse-nav-link ${activeNave === "general" ? "active" : ""
                        }`}
                      onClick={() => setActiveNav("general")}
                    >
                      General
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                      className={`collapse-nav-link ${activeNave === "other" ? "active" : ""
                        }`}
                      onClick={() => setActiveNav("other")}
                    >
                      Others
                    </div>
                  </div>
                </td>
              </tr>
              {activeNave === "general" ? (
                <>
                  <tr>
                    <td colSpan={3}>Order no.</td>
                    <td colSpan={5} style={{ width: "20%" }}>
                      {runningOrder?.local_order_id}
                    </td>
                    <td colSpan={3}>Payment</td>
                    <td colSpan={5} style={{ width: "20%" }}>
                      {runningOrder?.payment_status !== 0
                        ? printDependencies?.users?.find(i => i.user_uuid === runningOrder?.payment_by_user_uuid)?.user_title
                        : "Unpaid"}
                      {printDependencies?.invoice_setup?.invoice_field_customization?.payment_mode ===
                        "1" &&
                        runningOrder?.payment_status !== 0 &&
                        " - "}
                      {printDependencies?.invoice_setup?.invoice_field_customization?.payment_mode ===
                        "1" && runningOrder?.payment_status !== 0
                        ? runningOrder?.payment_details?.length === 1
                          ? printDependencies?.paymentMode?.length
                            ? printDependencies?.paymentMode
                              ?.filter((item) => item.payment_mode_uuid === runningOrder?.payment_details[0].payment_mode_uuid)
                              ?.[0]?.payment_mode_name
                            : "Multi"
                          : "" : ""}
                    </td>
                    <td colSpan={3}>Created At</td>
                    <td colSpan={5} style={{ width: "20%" }}>
                      {(runningOrder && +runningOrder.created_at) && new Date(+runningOrder?.created_at).toString().replace(' (India Standard Time)', '')}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>Order Total</td>
                    <td colSpan={5}>Rs {runningOrder?.order_total}</td>
                    <td colSpan={3}>Preparation Status</td>
                    <td colSpan={5}>
                      {runningOrder?.preparation_status === 0
                        ? "Processing"
                        : runningOrder?.preparation_status === 1
                          ? "Ready"
                          : "Cancelled"}
                    </td>
                    <td colSpan={3}>Completed At</td>
                    <td colSpan={5}>
                      {(runningOrder && +runningOrder.completed_at) ? new Date(+runningOrder?.completed_at).toString().replace(' (India Standard Time)', '') : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>At</td>
                    <td colSpan={5}>
                      {runningOrder?.order_type === 1
                        ? "Take Away"
                        : runningOrder?.order_type === 2
                          ? "Delivery"
                          : runningOrder?.order_type === 3
                            ? "Zomato"
                            : runningOrder?.order_type === 4
                              ? "Swiggy"
                              : runningOrder?.order_type === 5
                                ? "Meals"
                                : `${printDependencies?.seat_name} - ${printDependencies?.section_name}`}
                    </td>
                    <td colSpan={3}>Delivery Status</td>
                    <td colSpan={5}>-</td>
                    <td colSpan={3}>
                      {runningOrder?.customer_name !== "" ||
                        runningOrder?.customer_mobile !== ""
                        ? "Customer"
                        : ""}
                    </td>
                    <td colSpan={5}>
                      {(runningOrder?.customer_name !== ""
                        ? runningOrder?.customer_name
                        : "") +
                        (runningOrder?.customer_name !== "" &&
                          runningOrder?.customer_mobile !== ""
                          ? " - "
                          : "") +
                        (runningOrder?.customer_mobile !== ""
                          ? runningOrder?.customer_mobile
                          : "")}
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  <tr>
                    <td colSpan={1} style={{ width: "12%" }}>
                      Subtotal
                    </td>
                    <td colSpan={5} style={{ width: "12%" }}>
                      {kotItemDetails.length
                        ? kotItemDetails?.length > 1
                          ? kotItemDetails
                            ?.map((a) => {
                              let arr = [];
                              arr.push(a.order_item_unit_price);
                              if (a.addon_details?.length) {
                                arr.push(
                                  a.addon_details.length > 1
                                    ? a.addon_details?.reduce(
                                      (c, d) =>
                                        parseInt(c.price) + parseInt(d.price)
                                    )
                                    : parseInt(a.addon_details[0].price)
                                );
                              }

                              if (a.multi_details?.length) {
                                arr.push(
                                  a.multi_details.length > 1
                                    ? a.multi_details?.reduce(
                                      (c, d) =>
                                        parseInt(c.price) + parseInt(d.price)
                                    )
                                    : parseInt(a.multi_details[0].price)
                                );
                              }
                              if (arr.length > 1) {
                                return (
                                  arr.reduce(
                                    (a, b) => parseInt(a) + parseInt(b)
                                  ) * a?.order_item_qty
                                );
                              } else {
                                return arr[0] * a?.order_item_qty;
                              }
                            })
                            .reduce((a, b) => a + b)
                          : (() => {
                            let arr = [];
                            arr.push(kotItemDetails[0].order_item_unit_price);
                            if (kotItemDetails[0].addon_details?.length) {
                              arr.push(
                                kotItemDetails[0].addon_details.length > 1
                                  ? kotItemDetails[0].addon_details?.reduce(
                                    (c, d) =>
                                      parseInt(c.price) + parseInt(d.price)
                                  )
                                  : parseInt(
                                    kotItemDetails[0].addon_details[0].price
                                  )
                              );
                            }

                            if (kotItemDetails[0].multi_details?.length) {
                              arr.push(
                                kotItemDetails[0].multi_details.length > 1
                                  ? kotItemDetails[0].multi_details?.reduce(
                                    (c, d) =>
                                      parseInt(c.price) + parseInt(d.price)
                                  )
                                  : parseInt(
                                    kotItemDetails[0].multi_details[0].price
                                  )
                              );
                            }
                            if (arr.length > 1) {
                              return (
                                arr.reduce(
                                  (a, b) => parseInt(a) + parseInt(b)
                                ) * kotItemDetails[0]?.order_item_qty
                              );
                            } else {
                              return arr[0] * kotItemDetails[0]?.order_item_qty;
                            }
                          })()
                        : 0.0}
                    </td>
                    <td colSpan={1} style={{ width: "12%" }}>
                      Total Discount
                    </td>
                    <td
                      colSpan={5}
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        width: "12%",
                      }}
                    >
                      <div
                        onMouseEnter={() => discountPopVisible !== 'click' && setDiscountPopVisible("hover")}
                        onMouseLeave={() => discountPopVisible === "hover" && setDiscountPopVisible(false)}
                        onClick={() => discountPopVisible === 'click' ? setDiscountPopVisible(false) : setDiscountPopVisible('click')}
                      >
                        {runningOrder?.charges_and_discounts?.filter(
                          (a) => a.type === "D"
                        )?.length
                          ? runningOrder?.charges_and_discounts
                            ?.filter((a) => a.type === "D")
                            .map(
                              (d) =>
                                parseInt(d?.amt) || parseInt(d?.equivalent_amt)
                            )?.length > 1
                            ? runningOrder?.charges_and_discounts
                              ?.filter((a) => a.type === "D")
                              .map(
                                (d) =>
                                  parseInt(d?.amt) || parseInt(d?.equivalent_amt)
                              )
                              ?.reduce((a, b) => a + b)
                            : runningOrder?.charges_and_discounts
                              ?.filter((a) => a.type === "D")
                              .map(
                                (d) =>
                                  parseInt(d?.amt) || parseInt(d?.equivalent_amt)
                              )[0]
                          : 0}
                      </div>

                      {discountPopVisible &&
                        runningOrder?.charges_and_discounts?.filter(
                          (a) => a.type === "D"
                        )?.length ? (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                          }}
                        >
                          <div id="talkbubble">
                            {discountsInputValues && discountsInputValues.map((c) => (
                              <tr key={Math.random()}>
                                <td
                                  style={{
                                    fontSize: "small",
                                    color: "white",
                                  }}
                                  colSpan={2}
                                >
                                  {!editValue ? c.title :
                                    <input
                                      type='text'
                                      className="value-edit-inputs dark"
                                      onChange={e => onInputValChange(e, "title", c)}
                                      defaultValue={c.title}
                                    />
                                  }:
                                </td>
                                <td
                                  style={{
                                    fontSize: "small",
                                    color: "white",
                                  }}
                                >
                                  {!editValue ? c.amt || c.percent :
                                    <input
                                      type='number'
                                      className="value-edit-inputs dark"
                                      onChange={e => onInputValChange(e, "amount", c)}
                                      defaultValue={c.amt || c.percent}
                                    />
                                  }{c.percent && "%"}
                                </td>
                              </tr>
                            ))}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                    <td colSpan={1} style={{ width: "12%" }}>
                      Payment Time
                    </td>
                    <td colSpan={5} style={{ width: "12%" }}>
                      {" "}
                      {runningOrder?.payment_at
                        ? printDependencies?.dateFormat
                          ?.replace(
                            "mm",
                            (
                              "00" +
                              new Date(
                                parseFloat(runningOrder?.payment_at)
                              )?.getMonth() +
                              (1).toString()
                            ).slice(-2)
                          )
                          ?.replace(
                            "yy",
                            (
                              "0000" +
                              new Date(parseFloat(runningOrder?.payment_at))
                                .getFullYear()
                                .toString()
                            ).slice(-4)
                          )
                          ?.replace(
                            "dd",
                            (
                              "00" +
                              new Date(parseFloat(runningOrder?.payment_at))
                                .getDay()
                                .toString()
                            ).slice(-2)
                          ) +
                        " " +
                        (
                          "00" +
                          new Date(parseFloat(runningOrder?.payment_at))
                            .getHours()
                            .toString()
                        ).slice(-2) +
                        ":" +
                        (
                          "00" +
                          new Date(parseFloat(runningOrder?.payment_at))
                            .getMinutes()
                            .toString()
                        ).slice(-2)
                        : "Unpaid"}
                    </td>
                    <td colSpan={1} style={{ width: "12%" }}>
                      UUID
                    </td>
                    <td
                      colSpan={5}
                      onClick={() => {
                        setCopymsg(true);
                        navigator.clipboard.writeText(runningOrder?.order_uuid);
                        setTimeout(() => setCopymsg(false), 1000);
                      }}
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        width: "12%",
                      }}
                      onMouseOver={() => setUuid(true)}
                      onMouseLeave={() => setUuid(false)}
                    >
                      {runningOrder?.order_uuid?.substring(0, 7) + "..."}
                      {copymsg && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                          }}
                        >
                          <div id="talkbubble">COPIED!</div>
                        </div>
                      )}
                      {"   "}
                      <ContentCopy
                        style={
                          uuid
                            ? { fontSize: "12px", transform: "scale(1.5)" }
                            : { fontSize: "12px" }
                        }
                        onClick={() => {
                          setCopymsg(true);
                          navigator.clipboard.writeText(runningOrder?.order_uuid);
                          setTimeout(() => setCopymsg(false), 1000);
                        }}
                      />
                      {uuid && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                          }}
                        >
                          <div id="talkbubble">{runningOrder?.order_uuid}</div>
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={1}>Total GST</td>
                    <td colSpan={5}> {runningOrder?.total_tax_gst}</td>
                    <td colSpan={1}>Total Charges</td>
                    <td
                      colSpan={5}
                      style={{
                        cursor: "pointer",
                        position: "relative",
                      }}
                    >
                      <div
                        onMouseEnter={() => chargesPopVisible !== 'click' && setIsChargesPopVisible("hover")}
                        onMouseLeave={() => chargesPopVisible === "hover" && setIsChargesPopVisible(false)}
                        onClick={() => chargesPopVisible === 'click' ? setIsChargesPopVisible(false) : setIsChargesPopVisible('click')}
                      >
                        {runningOrder?.charges_and_discounts?.filter(
                          (a) => a.type === "C"
                        )?.length
                          ? runningOrder?.charges_and_discounts
                            ?.filter((a) => a.type === "C")
                            .map(
                              (d) =>
                                parseInt(d?.amt) || parseInt(d?.equivalent_amt)
                            )?.length > 1
                            ? runningOrder?.charges_and_discounts
                              ?.filter((a) => a.type === "C")
                              .map(
                                (d) =>
                                  parseInt(d?.amt) || parseInt(d?.equivalent_amt)
                              )
                              ?.reduce((a, b) => a + b)
                            : runningOrder?.charges_and_discounts
                              ?.filter((a) => a.type === "C")
                              .map(
                                (d) =>
                                  parseInt(d?.amt) || parseInt(d?.equivalent_amt)
                              )[0]
                          : 0}
                      </div>
                      {chargesPopVisible &&
                        runningOrder?.charges_and_discounts?.filter(
                          (a) => a.type === "C"
                        )?.length ? (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                          }}
                        >
                          <div id="talkbubble">
                            {chargesInputValues && chargesInputValues.map((c) => (
                              <tr
                                key={Math.random()}
                              >
                                <td
                                  style={{
                                    fontSize: "small",
                                    color: "white",
                                  }}
                                  colSpan={2}
                                >
                                  {!editValue ? c.title :
                                    <input
                                      type='text'
                                      className="value-edit-inputs dark"
                                      onChange={e => onInputValChange(e, "title", c)}
                                      defaultValue={c.title}
                                    />
                                  }
                                  :
                                </td>
                                <td
                                  style={{
                                    fontSize: "small",
                                    color: "white",
                                  }}
                                >
                                  {!editValue ? c.amt || c.percent :
                                    <input
                                      type='number'
                                      className="value-edit-inputs dark"
                                      onChange={e => onInputValChange(e, "amount", c)}
                                      defaultValue={c.amt || c.percent}
                                    />
                                  }{c.percent && "%"}
                                </td>
                              </tr>
                            ))}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                    <td colSpan={1}>Payment by</td>
                    <td colSpan={5}>{printDependencies?.users?.find(i => i.user_uuid === runningOrder?.payment_by_user_uuid)?.user_title || "Unpaid"}</td>
                    <td colSpan={1}>Working Day</td>
                    <td colSpan={5}>
                      <label htmlFor="edit-working-day">
                        {runningOrder && +runningOrder?.working_day ?
                          new Date(workingDay).toString().replace(' (India Standard Time)', '')
                          : "Not Updated"}
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={1}>Total Vat</td>
                    <td colSpan={5}>{runningOrder?.total_tax_vat}</td>
                    <td colSpan={1}>Order Total</td>
                    <td colSpan={5}>Rs {runningOrder?.order_total}</td>
                    <td colSpan={1}>Delivery Address</td>
                    <td colSpan={5} style={{ cursor: "pointer" }} onClick={e => toggleDeliveryBox(!showDeliveryBox)}>
                      {runningOrder?.delivery_address?.slice(0, 13) || "No Address"}
                      {runningOrder?.delivery_address?.length > 13 && "..."}
                      {runningOrder?.delivery_address && showDeliveryBox && <div
                        style={{
                          position: "absolute",
                          top: "100%",
                        }}
                      >
                        <div id="talkbubble" className="delivery-box">
                          {runningOrder?.delivery_address}
                        </div>
                      </div>}
                    </td>
                    <td colSpan={1}>Last Updated At</td>
                    <td colSpan={5}>
                      {runningOrder && +runningOrder?.modified_at ?
                        new Date(+runningOrder?.modified_at).toString().replace(' (India Standard Time)', '')
                        : "Not Updated"}
                    </td>
                  </tr>
                </>
              )}
            </thead>
          </table>
          <div style={{ overflowY: "auto", maxHeight: "50vh" }}>
            <table className="order-detail">
              {runningOrder?.order_kot_details?.map((item, i) => (
                <>
                  <tbody>
                    <tr style={{ border: "none" }}>
                      <td colSpan={6}>
                        <div className="collapse-info">
                          <div className="KOT">
                            KOT <b>{item?.kot}</b>
                          </div>
                          <div className="created">
                            Created{" "}
                            <b>
                              {new Date(+item?.created_at || +runningOrder.created_at).toString().replace(' (India Standard Time)', '')}
                            </b>
                          </div>
                          <div className="by">
                            By <b>-</b>
                          </div>
                          <div className="amt">
                            Amt{" "}
                            <b>
                              Rs{" "}
                              {
                                runningOrder?.order_kot_details.find(
                                  (item1) => item1?.kot === item?.kot
                                )?.kot_total
                              }
                            </b>
                          </div>
                          <div className="qty">
                            Qty{" "}
                            <b>
                              {kotItemDetails
                                ?.filter((item2) => item2?.kot === item?.kot)
                                ?.map((a) => a.order_item_qty).length > 1
                                ? kotItemDetails
                                  ?.filter((item2) => item2?.kot === item?.kot)
                                  ?.map((a) => a?.order_item_qty)
                                  .reduce((a, b) => a + b)
                                : kotItemDetails?.filter(
                                  (item2) => item2?.kot === item?.kot
                                )[0]?.order_item_qty}
                            </b>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: 'start' }}>S.No</td>
                      <td>Item</td>
                      <td>Qty</td>
                      <td>Price</td>

                      <td>Amount</td>
                      <td>Chef</td>
                    </tr>
                    {itemsList && cancelledItems && kotItemDetails
                      ?.filter((item2) => item2?.kot === item?.kot)
                      ?.map((data, ci) => (
                        <tr
                          key={Math.random()}
                          className={`kot-item ${(cancelledItems[item?.kot]?.includes(ci))
                            ? "cancelled" : +data?.order_item_status === 1 && !cancelledItems[item?.kot]?.includes(ci)
                              ? "prepared" : "unprepared"}`
                          }
                        >
                          <td className="edit-order-index">
                            {editValue && cancelledItems[item.kot]?.includes(ci) ?
                              <ReplayCircleFilledOutlined
                                className="undo-cancel-item"
                                onClick={+restrictions[0]?.complete_order_item_status === 0 && location.pathname === "/report-orders" ?
                                  () => {
                                    setUnAuthPopup(true);
                                    setTimeout(() => setUnAuthPopup(false), 3000)
                                  }
                                  : +restrictions[0]?.running_order_item_status === 0 ?
                                    () => {
                                      setUnAuthPopup(true);
                                      setTimeout(() => setUnAuthPopup(false), 3000)
                                    } :
                                    e => {
                                      setCancelledItems({
                                        ...cancelledItems, [item.kot]:
                                          cancelledItems[item.kot] ? cancelledItems[item.kot]?.filter(i => i !== ci) : []
                                      });
                                    }}
                              />
                              : editValue && (!cancelledItems[item.kot]?.includes(ci)) ?
                                <Cancel
                                  className="cancel-item"
                                  onClick={+restrictions[0]?.complete_order_item_status === 0 && location.pathname === "/report-orders" ?
                                    () => {
                                      setUnAuthPopup(true);
                                      setTimeout(() => setUnAuthPopup(false), 3000)
                                    }
                                    : +restrictions[0]?.running_order_item_status === 0 ?
                                      () => {
                                        setUnAuthPopup(true);
                                        setTimeout(() => setUnAuthPopup(false), 3000)
                                      } : e => {
                                        setCancelledItems({
                                          ...cancelledItems, [item.kot]:
                                            cancelledItems[item.kot] ? [...cancelledItems[item.kot]?.filter(i => i !== ci), ci] : [ci]
                                        });
                                      }}
                                />
                                : ""}
                            {ci + 1}
                          </td>

                          <td>
                            {data?.parcel === "Y" ? (
                              <span style={{ color: "blue" }}>[Parcel] </span>
                            ) : (
                              ""
                            )}{" "}
                            {itemsList.find(
                              (itemdata) => itemdata.item_uuid === data.item_uuid
                            )
                              ? itemsList.find(
                                (itemdata) => itemdata.item_uuid === data.item_uuid
                              )?.item_name
                              : ""}
                            {data.order_item_instruction ? (
                              <>
                                <br />
                                <span
                                  style={{ color: "blue" }}
                                >{`[${data.order_item_instruction}]`}</span>
                              </>
                            ) : (
                              ""
                            )}
                            {data?.addon_details?.map((addonDetails, ai) => (
                              <div key={Math.random()} style={{ display: "flex", alignItems: "center" }}>
                                {editValue && !cancelledItems[item.kot]?.includes(ci) && data?.order_item_status !== 2 &&
                                  <AddRemoveBtns
                                    removedItemExtras={removedItemExtras}
                                    setRemovedItemExtras={setRemovedItemExtras}
                                    item={item}
                                    item_index={ci}
                                    extras_index={ai}
                                    type={"addons"}
                                    restrictions={restrictions}
                                    setUnAuthPopup={setUnAuthPopup}
                                  />
                                }
                                <i style={{
                                  color: (+data?.order_item_status === 2
                                    && cancelledItems[item.kot]?.includes(ci))
                                    || removedItemExtras?.[item.kot]?.[ci]?.addons?.includes(ai)
                                    ? 'red' : 'inherit'
                                }}>
                                  -{itemsList?.find(itemdata => itemdata?.item_uuid === addonDetails?.item_uuid)?.item_name}
                                </i>
                              </div>
                            ))}
                            {data?.multi_details?.map((MultiDetails, mi) => (
                              <div key={Math.random()} style={{ color: (data?.order_item_status === 2 || cancelledItems[item.kot]?.includes(ci)) || removedItemExtras?.[item.kot]?.[ci]?.multi?.includes(mi) ? 'red' : 'green' }}>
                                {editValue && !cancelledItems[item.kot]?.includes(ci) && data?.order_item_status !== 2 &&
                                  <AddRemoveBtns
                                    removedItemExtras={removedItemExtras}
                                    setRemovedItemExtras={setRemovedItemExtras}
                                    item={item}
                                    item_index={ci}
                                    extras_index={mi}
                                    type={"multi"}
                                    restrictions={restrictions}
                                    setUnAuthPopup={setUnAuthPopup}
                                  />
                                }
                                <i style={{
                                  color: +data?.order_item_status === 2
                                    || cancelledItems[item.kot]?.includes(ci)
                                    || removedItemExtras?.[item.kot]?.[ci]?.multi?.includes(mi)
                                    ? 'red' : 'inherit'
                                }}>
                                  +{MultiDetails.name}
                                </i>
                              </div>
                            ))}
                          </td>
                          {editValue ?
                            editedData && <td>
                              <input
                                type="number"
                                className="value-edit-inputs qty"
                                // defaultValue={data?.order_item_qty}
                                item-index={ci}
                                kot={item?.kot}
                                id={`${item?.kot}-${ci}-qty`}

                                value={editedData.data[item?.kot][ci]?.qty}
                                onChange={+restrictions[0]?.complete_order_edit_item_qty === 0 && location.pathname === "/report-orders" ?
                                  () => {
                                    setUnAuthPopup(true);
                                    setTimeout(() => setUnAuthPopup(false), 3000)
                                  }
                                  : +restrictions[0]?.running_order_edit_item_qty === 0 ?
                                    () => {
                                      setUnAuthPopup(true);
                                      setTimeout(() => setUnAuthPopup(false), 3000)
                                    } : e => {
                                      const data = {
                                        ...editedData.data, [item?.kot]: {
                                          ...editedData.data[item?.kot],
                                          [ci]: {
                                            ...editedData.data[item?.kot][ci],
                                            qty: e.currentTarget.value
                                          }
                                        }
                                      }
                                      setEditedData({ data: data, id: e.currentTarget.id })
                                    }}
                                autoFocus={editedData.id === `${item?.kot}-${ci}-qty` ? true : false}
                              />
                            </td>
                            :
                            <td>{data?.order_item_qty}</td>}
                          <td>
                            {editValue ?
                              editedData && <input
                                type="number"
                                className="value-edit-inputs unit-price"
                                // defaultValue={data?.order_item_unit_price}
                                item-index={ci}
                                kot={item?.kot}
                                id={`${item?.kot}-${ci}-price`}

                                value={editedData.data[item?.kot][ci]?.price}
                                onChange={+restrictions[0]?.complete_order_price === 0 && location.pathname === "/report-orders" ?
                                  () => {
                                    setUnAuthPopup(true);
                                    setTimeout(() => setUnAuthPopup(false), 3000)
                                  }
                                  : +restrictions[0]?.running_order_price === 0 ?
                                    () => {
                                      setUnAuthPopup(true);
                                      setTimeout(() => setUnAuthPopup(false), 3000)
                                    } : e => {
                                      const data = {
                                        ...editedData.data, [item?.kot]: {
                                          ...editedData.data[item?.kot],
                                          [ci]: {
                                            ...editedData.data[item?.kot][ci],
                                            price: e.currentTarget.value
                                          }
                                        }
                                      }
                                      setEditedData({ data: data, id: e.currentTarget.id })
                                    }}
                                autoFocus={editedData.id === `${item?.kot}-${ci}-price` ? true : false}
                              />
                              :
                              data?.order_item_unit_price
                            }
                            {data?.addon_details?.map((MultiDetails) => (
                              <>
                                <br />
                                {MultiDetails.price}
                              </>
                            ))}
                            {data?.multi_details?.map((MultiDetails) => (
                              <>
                                <br />
                                {MultiDetails.price}
                              </>
                            ))}
                          </td>

                          <td>
                            {data?.order_item_qty * data?.order_item_unit_price}
                            {data?.addon_details?.map((MultiDetails) => (
                              <>
                                <br />
                                {data?.order_item_qty * MultiDetails.price}
                              </>
                            ))}
                            {data?.multi_details?.map((MultiDetails) => (
                              <>
                                <br />
                                {data?.order_item_qty * MultiDetails.price}
                              </>
                            ))}
                          </td>

                          <td>
                            {printDependencies?.users?.find(user => user?.user_uuid === data?.prepared_by)?.user_title || "-"}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </>
              ))}
            </table></div>
        </td>
        <td id="buttons-container">
          {editValue ?
            <>
              <button onClick={e => {
                if (page.includes("report-orders")) {
                  const editedOrder = performCalculation(runningOrder)
                  paymentProps = { printKotInvoice, handleInvoicePrint }
                  setPaymentOptionOpen({
                    status: true,
                    amount: editedOrder.order_total,
                    order: editedOrder,
                    orderProps: {
                      order_uuids: [runningOrder?.order_uuid],
                      order_status_param: runningOrder?.order_status
                    },
                    callback: (order) => {
                      console.log("-----------", order);
                      setEditValue(false);
                      setRunningOrder(order);
                      setIsOrdersTablePopUpOpen(false);
                    },
                  })
                }
                else
                  updateOrder()
              }}
                className='save'
              >
                Save
              </button>
              <button onClick={e => setEditValue(false)} className='cancel'>
                Cancel
              </button>
            </>
            :
            <button onClick={+restrictions[0]?.complete_order_edit === 0 && location.pathname === "/report-orders" ? () => {
              setUnAuthPopup(true);
              setTimeout(() => setUnAuthPopup(false), 3000)
            } : +restrictions[0]?.running_order_editing === 0 ? () => {
              setUnAuthPopup(true);
              setTimeout(() => setUnAuthPopup(false), 3000)
            } : () => setEditValue(true)
            }
              className='edit'>
              Edit
            </button>}
          {editValue && <button className='edit' onClick={
            +restrictions[0]?.complete_order_add_item === 0 && location.pathname === "/report-orders" ? () => {
              setUnAuthPopup(true);
              setTimeout(() => setUnAuthPopup(false), 3000)
            } : +restrictions[0]?.running_order_add_item === 0 ? () => {
              setUnAuthPopup(true);
              setTimeout(() => setUnAuthPopup(false), 3000)
            } :
              e => openMenuToAddMoreItems()}>
            Add More Items
          </button>}
          {Array.isArray(kot_list) && kot_list.length > 0 ? <button className='edit'
            onClick={e => { setShowKots(!showKots); setShowInvoiceMenu(false) }}>
            KOT
          </button> : ""}
          <button className='edit' onClick={e => { setShowInvoiceMenu(!showInvoiceMenu); setShowKots(false) }}>
            Invoice
          </button>
          {location.pathname === "/report-orders" ?
            <button
              className='edit'
              style={{ backgroundColor: "red" }}
              onClick={
                +restrictions[0]?.complete_order_delete === 0 ? () => {
                  setUnAuthPopup(true);
                  setTimeout(() => setUnAuthPopup(false), 3000)
                } : () => {

                  setShowDelete(true);
                  setShowKots(false);
                  setShowInvoiceMenu(false);
                }
              }
            >
              Delete
            </button>
            :
            <button
              className='edit'
              style={{ backgroundColor: "red" }}
              onClick={
                +restrictions[0]?.running_order_delete === 0 ? () => {
                  setUnAuthPopup(true);
                  setTimeout(() => setUnAuthPopup(false), 3000)
                } : () => {
                  setShowDelete(true);
                  setShowKots(false);
                  setShowInvoiceMenu(false);
                }
              }
            >
              Delete
            </button>
          }
        </td>

        {showInvoiceMenu ? <td id="details-popup-container" className={'active'}>
          <div
            onMouseEnter={e => showInvoiceMenu !== "close" && setShowInvoiceMenu('inside')}
            onMouseOut={e => showInvoiceMenu !== "close" && setShowInvoiceMenu(true)}
          >
            {/* <button onClick={e => invoice(e.currentTarget.innerText)}>0</button> */}
            {/* <button onClick={() => printInvoice(1, "false", "true")}>Print</button> */}
            <button onClick={() => handleInvoicePrint({ num: 1 })}>1</button>
            <button onClick={() => handleInvoicePrint({ num: 2 })}>2</button>
            <button onClick={() => handleInvoicePrint({ num: 1, ebill: true })}>eBill</button>
          </div>
        </td> : ""}

        <XIcon
          onClick={() => { setIsOrdersTablePopUpOpen(false); setRunningOrder(null) }}
          className="xiconOrder"
        />

        {showKots &&
          <td id="details-popup-container" className={showKots ? 'active' : ''}>
            <div>{runningOrder?.order_kot_details?.map(kot => <button onClick={() => printKotInvoice(kot?.kot)}>{kot?.kot}</button>)}</div>
          </td>}

        {showDelete ?
          <div className="secondary_screen">
            <div className="logoutPopup" style={{ left: "0px" }}>
              <DeleteConfirmation
                onConfirm={() => {

                  if (page.includes("/report-orders"))
                    onOrderDelete();
                  else
                    deleteOrder(runningOrder.order_uuid)

                  setShowDelete(false);
                  setIsOrdersTablePopUpOpen(false)
                }}
                onCancel={() => {
                  setShowDelete(false);
                }}
              />
            </div>
          </div> : ""}

        <div className="edit-order date-picker-container">
          {editValue && <DatePicker
            id="edit-working-day"
            className="date-picker edit-order test"
            selected={workingDay}
            maxDate={new Date()}
            onChange={
              +restrictions[0]?.complete_order_change_working_day === 0 ? () => {
                setUnAuthPopup(true);
                setTimeout(() => setUnAuthPopup(false), 3000)
              } : (date) =>
                setWorkingDay(date)
            }
            wrapperClassName=""
            shouldCloseOnSelect={true}
          />}
        </div>
      </tr>}
    </>
  );
};

export default TableRowCollapse;
const DeleteConfirmation = ({ onConfirm, onCancel }) => {
  return <div className="logoutPopup" style={{ zIndex: "99999", backgroundColor: "none" }}>
    <div className="logout_content">
      <h1 style={{ color: "red" }}>Are You Sure!!!</h1>

      <div className="logout_button">
        <div className="button_container">

          <button
            style={{ background: "red" }}
            className="clear_Logout_button"
            onClick={onConfirm}
          >
            Confirm
          </button>

        </div>
        <div className="button_container">
          <button
            className="simple_Logout_button"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>

  </div>
}

const AddRemoveBtns = ({ removedItemExtras, setRemovedItemExtras, item, item_index, extras_index, type, restrictions, setUnAuthPopup }) => (<>
  {removedItemExtras?.[item.kot]?.[item_index]?.[type]?.includes(extras_index)
    ? <ReplayCircleFilledOutlined
      className="undo-cancel-item"
      style={{ color: 'green', fontSize: "1.2rem" }}
      onClick={+restrictions[0]?.complete_order_item_status === 0 && window.location.pathname === "/report-orders" ?
        () => {
          setUnAuthPopup(true);
          setTimeout(() => setUnAuthPopup(false), 3000)
        }
        : +restrictions[0]?.running_order_item_status === 0 ?
          () => {
            setUnAuthPopup(true);
            setTimeout(() => setUnAuthPopup(false), 3000)
          } :
          e => {
            setRemovedItemExtras(doc => ({
              ...doc,
              [+item.kot]: {
                ...(doc?.[+item.kot] || {}),
                [item_index]: {
                  ...(doc?.[+item.kot]?.[item_index] || {}),
                  [type]: (doc[+item.kot]?.[item_index]?.[type] || [])?.filter(i => i !== extras_index)
                }
              }
            }));
          }}
    />
    : <Cancel
      className="cancel-item"
      style={{ color: 'red', fontSize: "1.2rem" }}
      onClick={+restrictions[0]?.complete_order_item_status === 0 && window.location.pathname === "/report-orders" ?
        () => {
          setUnAuthPopup(true);
          setTimeout(() => setUnAuthPopup(false), 3000)
        }
        : +restrictions[0]?.running_order_item_status === 0 ?
          () => {
            setUnAuthPopup(true);
            setTimeout(() => setUnAuthPopup(false), 3000)
          } : e => {
            setRemovedItemExtras(doc => ({
              ...doc,
              [+item.kot]: {
                ...(doc?.[+item.kot] || {}),
                [item_index]: {
                  ...(doc?.[+item.kot]?.[item_index] || {}),
                  [type]: [...(doc[+item.kot]?.[item_index]?.[type] || []), extras_index]
                }
              }
            }));
          }}
    />}
</>)